import React from "react";

import "./NoutFoundStyles.css";

export const NoutFound = ({ text }) => {
  return <div className="not-found">{text}</div>;
};
